import { useState, useEffect } from 'react';
import { getToken, isSupported } from 'firebase/messaging';
import { getMessagingInstance, vapidKey } from '@/modules/notification';

export function useFCMToken(): string | null {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function acquire() {
      if (!('serviceWorker' in navigator)) {
        console.debug('[FCM] no serviceWorker'); // eslint-disable-line no-console
        return;
      }
      if (!vapidKey) {
        console.debug('[FCM] no vapidKey'); // eslint-disable-line no-console
        return;
      }
      const supported = await isSupported();
      if (!supported) {
        console.debug('[FCM] not supported'); // eslint-disable-line no-console
        return;
      }
      const messaging = getMessagingInstance();
      if (!messaging) {
        console.debug('[FCM] no messaging instance'); // eslint-disable-line no-console
        return;
      }
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;
      const swReg = await navigator.serviceWorker.ready;
      const fcmToken = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration: swReg,
      });
      if (cancelled) return;
      if (fcmToken) setToken(fcmToken);
    }

    acquire().catch(err => console.error('[FCM] error:', err)); // eslint-disable-line no-console
    return () => {
      cancelled = true;
    };
  }, []);

  return token;
}
